// link
import {Link} from "react-router-dom";
// copy
import {copyDivToClipboard} from "../../features/copyText/copyText";

const Modal = (props: any) => {
    return (
        <>
            <article className={'modal fade'} id={'modal-payment'}>
                <div className={'modal-dialog justify-content-center modal-sm modal-dialog-centered'}>
                    <div className={'modal-content share-modal justify-content-center rounded rounded-5'}>
                        <div className={'modal-body'}>
                            <div className="title text-center mb-3">
                                <h5 className="fw-bold text-center dark-green h5 mt-3">اشتراک گذاری</h5>
                            </div>
                            <div className={'row justify-content-center mt-3'}>
                                <div className={'col-7'}>
                                    <Link to={'#'} onClick={() => props.captureScreenshot()}
                                          className={'dark-green mb-3 rounded-pill align-middle font-medium btn-site btn fw-bold w-100'}>
                                        تصویر
                                        <svg className={'me-2'} width="24" height="24" viewBox="0 0 24 24" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                                                stroke="#171717" strokeWidth="2.3" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                            <path
                                                d="M9 10C10.1046 10 11 9.10457 11 8C11 6.89543 10.1046 6 9 6C7.89543 6 7 6.89543 7 8C7 9.10457 7.89543 10 9 10Z"
                                                stroke="#171717" strokeWidth="2.3" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                            <path
                                                d="M2.66998 18.9501L7.59998 15.6401C8.38998 15.1101 9.52998 15.1701 10.24 15.7801L10.57 16.0701C11.35 16.7401 12.61 16.7401 13.39 16.0701L17.55 12.5001C18.33 11.8301 19.59 11.8301 20.37 12.5001L22 13.9001"
                                                stroke="#171717" strokeWidth="2.3" strokeLinecap="round"
                                                strokeLinejoin="round"/>
                                        </svg>
                                    </Link>
                                    <Link to={'#'}
                                          onClick={() => copyDivToClipboard()}
                                          className={'dark-green mb-2 rounded-pill align-middle font-medium btn-site btn fw-bold w-100'}>
                                        <span id={'btn-text'}>
                                         متن
                                            <svg className={'me-2'} width="24" height="24" viewBox="0 0 24 24"
                                                 fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                               <path d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
                                                     stroke="#171717" strokeWidth="2.3"
                                                     strokeLinecap="round" strokeLinejoin="round"/>
                                               <path d="M22 10H18C15 10 14 9 14 6V2L22 10Z" stroke="#171717"
                                                     strokeWidth="2.3" strokeLinecap="round"
                                                     strokeLinejoin="round"/>
                                               <path d="M7 13H13" stroke="#171717" strokeWidth="2.3"
                                                     strokeLinecap="round" strokeLinejoin="round"/>
                                               <path d="M7 17H11" stroke="#171717" strokeWidth="2.3"
                                                     strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </>
    )
}

export default Modal;